module.exports = __webpack_public_path__ + "static/img/3ds.4a21ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/3ds.png
// module id = +vOD
// module chunks = 53